export const UsePostalQuery = {
  all: '全て',
  without: '郵送利用企業以外',
  only: '郵送利用企業のみ'
} as const;

export type UsePostalQueryKey = keyof typeof UsePostalQuery;

export const UsePostalQueryKeys: readonly UsePostalQueryKey[] = ['all', 'without', 'only'];
